module.exports = "<nv-react-component component=\"ReactAngularTranslationButton\" dispatch-store-updates=\"false\"></nv-react-component>";